// extracted by mini-css-extract-plugin
export default {"body":"custom-toggle_body__YfARq","selected":"custom-toggle_selected__aAZRY"};